export const checkExtension = (filename) => {
  return filename.split('.').pop();
};